import { Directive, ElementRef, Input } from "@angular/core";

@Directive({
    selector: "[se-autofocus]"
})
export class SeAutoFocusDirective {
    private focus = true;

    constructor(private el: ElementRef) {
    }

    ngOnInit() {
        if (this.focus) {
            //Otherwise Angular throws error: Expression has changed after it was checked.
            setTimeout(() => {
                this.el.nativeElement.focus(); //For SSR (server side rendering) this is not safe. Use: https://github.com/angular/angular/issues/15008#issuecomment-285141070)
            });
        }
    }

    @Input() set autofocus(condition: boolean) {
        this.focus = condition !== false;
    }
}
